import { render, staticRenderFns } from "./retirementSettings.vue?vue&type=template&id=60da916a&scoped=true"
import script from "./retirementSettings.vue?vue&type=script&lang=js"
export * from "./retirementSettings.vue?vue&type=script&lang=js"
import style0 from "./retirementSettings.vue?vue&type=style&index=0&id=60da916a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60da916a",
  null
  
)

export default component.exports